// 專題 關聯 新聞
import NewsComponent from '../basic/NewsComponent'; // 新聞元件

const ProjectRelatedNews = ({ t, newsList }) => {
    // 列表樣式：一則、兩則、多則
    const newsStyle = [
        'max-w-[382px] [&>*]:w-full umd:max-w-full',
        'max-w-[784px] [&>*]:w-[calc((100%-40px)/2)] blb:[&>*]:w-[calc((100%-20px)/2)] blg:[&>*]:w-[calc((100%-20px)/2)]',
        '[&>*]:w-[calc((100%-40px)/3)] blb:[&>*]:w-[calc((100%-20px)/2)] blg:[&>*]:w-[calc((100%-20px)/2)]',
    ];

    return (
        <section
            className={`${
                newsStyle[newsList?.length > 2 ? 2 : newsList.length - 1]
            } mx-auto relative flex flex-wrap gap-x-[20px] gap-y-[35px] py-[56px] umd:[&>*]:w-full umd:py-[30px]`}
        >
            {/* 關聯新聞 */}
            {newsList?.map((news, i) => (
                <NewsComponent
                    key={news?.title + i + 'project'}
                    t={t}
                    news={news}
                    location={'project'}
                />
            ))}

            {/* 背景色 */}
            <div className="absolute !w-screen h-full z-[0] top-0 left-[50%] translate-x-[-50%] bg-black1" />
        </section>
    );
};

export default ProjectRelatedNews;
